<template>
    <b-col>
        <b-form-group :label="label" :label-for="id ? id : 'IsActive'">
            <b-form-checkbox v-model="value" v-on:change="$emit('onChange')" v-on:input="$emit('input', $event)" :id="id ? id : 'IsActive'">
            </b-form-checkbox>
        </b-form-group>
    </b-col>
</template>

<script>
export default {
  name: "filter-checkbox",
  props: ["value", "label", "id"]
};
</script>
